/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

export const useHistoricoGrupos = () => {
  const url = `${backofficeEnviroment}/common/backoffice/chat/grupos/v1`;

  const fetchData = async () => {
    const response = await instance.get(url);
    return response?.data?.data;
  };

  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["get-historico-grupos"],
    refetchOnWindowFocus: false,
  });

  return query;
};
